import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

export const filtersKeyMap = {
  planning_hide_alerts_by_default: 'hideAlerts',
  display_absences_in_planning: 'showAbsences',
  display_availabilities_in_planning: 'showAvailabilities',
  display_unscheduled_employees_in_planning: 'showUnscheduledEmployees',
  display_shifts_from_other_teams: 'showOtherTeamsShifts',
  display_ct_counter_in_planning: 'showCTCounter',
  display_only_extras_and_interims_in_planning: 'showOnlyExtrasAndInterims',
  display_unassigned_shifts_row: 'showUnassignedShiftsRow'
}

export const updateFiltersKeyMap = Object.entries(filtersKeyMap).reduce(
  (acc, [updateKey, storeKey]) => {
    acc[storeKey] = updateKey
    return acc
  },
  {}
)

export type DisplayFilters = {
  hideAlerts?: boolean
  showAbsences?: boolean
  showAvailabilities?: boolean
  showCTCounter?: boolean
  showUnscheduledEmployees?: boolean
  showOnlyExtrasAndInterims?: boolean
  showOtherTeamsShifts?: boolean
  showUnassignedShiftsRow?: boolean
  searchContract?: string | undefined
}

export type DisplayFilterName = keyof DisplayFilters

const initialState: DisplayFilters = {
  hideAlerts: false,
  showAbsences: true,
  showAvailabilities: true,
  showUnscheduledEmployees: true,
  showOtherTeamsShifts: true,
  showCTCounter: true,
  showOnlyExtrasAndInterims: false,
  showUnassignedShiftsRow: true,
  searchContract: ''
}

const displayFiltersSlice = createSlice({
  name: 'ui/planning/displayFilters',
  initialState,
  reducers: {
    setDisplayFilters(state, action: PayloadAction<Partial<DisplayFilters>>) {
      return { ...state, ...action.payload }
    },
    clearDisplayFilters() {
      return { ...initialState }
    }
  }
})

export const { setDisplayFilters, clearDisplayFilters } =
  displayFiltersSlice.actions
export default displayFiltersSlice.reducer
